import { ActionCreator } from 'helper/redux';

export const AppActionCreators = {
  resetAllState: new ActionCreator<'app/ResetAllState', void>('app/ResetAllState')
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/app.ts